<template>
	<modal
		max-width="950px"
		max-height="700px"
		:exibir="exibir"
		:titulo="tituloModal"
		custom-actions
		@close="fecharModal"
	>
		<template #body>
			<listagem-modal-documentos
				:itens="datasource"
				:total-paginas="totalPaginas"
				:total-itens="totalItens"
				:paginacao="paginacao"
				@paginar="setPaginacao"
				@resetar-page="resetarPaginaListagem"
			>
			</listagem-modal-documentos>
		</template>
	</modal>
</template>
<script>
import { actionTypes } from '@/core/constants'
import ListagemModalDocumentos from '@/views/pages/ata/pesquisa/listagem/modal-documentos/listagem/ListagemModalDocumentos'
import mutationTypes from '@/core/constants/mutation-types'
import Modal from '@/views/components/Modal'

export default {
	name: 'modal-documentos',
	components: { Modal, ListagemModalDocumentos },
	props: {
		tituloModal: {
			type: String,
			default: 'Documentos',
		},
		exibir: {
			type: Boolean,
		},
		idAta: {
			type: Number,
			required: true,
		},
	},
	emits: ['fechar-modal', 'baixar-arquivo'],
	data() {
		return {
			paginacao: this.$store.state.documentos.paginacao,
			datasource: [],
			totalPaginas: 0,
			totalItens: 0,
		}
	},
	async mounted() {
		this.setIdAta()
		await this.carregarItens()
	},
	beforeDestroy() {
		this.resetarPaginaListagem()
		this.resetarPaginacao()
	},
	methods: {
		async carregarItens() {
			const retorno = await this.$store.dispatch(actionTypes.DOCUMENTOS.BUSCAR_POR_FILTRO)

			this.datasource = retorno.itens
			this.totalItens = retorno.totalElements
			this.totalPaginas = retorno.totalPages
		},
		fecharModal() {
			this.$emit('fechar-modal')
		},
		setIdAta() {
			this.$store.commit(mutationTypes.DOCUMENTOS.SET_ID_ATA, this.idAta)
		},
		setPaginacao(paginacao) {
			this.$store.commit(mutationTypes.DOCUMENTOS.SET_PAGINACAO_LISTAGEM, paginacao)
			this.carregarItens()
		},
		resetarPaginaListagem() {
			this.$store.commit(mutationTypes.DOCUMENTOS.RESETAR_PAGINA_LISTAGEM)
		},
		resetarPaginacao() {
			this.$store.commit(mutationTypes.DOCUMENTOS.RESETAR_PAGINACAO_LISTAGEM)
		},
	},
}
</script>
